"use client";

import React from "react";
import PropTypes from "prop-types";
import {
   MediaAgeVerificationFrame as AgeVerificationFrame,
} from 'common/components/modules/media';
import { MediaPreviewVideo, MediaImageCard, MediaLockedCard } from 'common/designer-modules/modules/media/modules';
import { isDrmTokenBasedLicenseIssuanceForMember } from 'common/utils/utils';

import VideoJsHlsPlayer from 'common/components/modules/video-js-hls-player';

const VideoMediaContent = ({
   data,
   src,
   isAgeVerificationRequired,
   autoPlayPreview,
   primaryColor,
   addView = () => {},
   authUser,
   siteInfo,
   getDrmVideoLicenseProxyUrl,
   getDrmVideoLicenseToken,
   authToken,
}) => {
   const poster = data.poster_src;
   const previewSrc = data.custom_preview_video_full_src || data.system_preview_video_full_src;
   const posterIsSfw = isAgeVerificationRequired && !data.thumbnail_is_sfw;
   const previewIsSFW = isAgeVerificationRequired && !data.preview_is_sfw;
   const videoIsSfw = isAgeVerificationRequired && !data.video_is_sfw;

   // video_is_sfw
   if(src){ // VIDEO PLAYER
      const video_watermark_settings = siteInfo?.video_watermark_settings || {};
      const watermarks_options = video_watermark_settings.watermarks_options || {};
      const show_member_info = video_watermark_settings.show_member_info;
      const show_member_email = video_watermark_settings.show_member_email;
      const show_member_username = video_watermark_settings.show_member_username;
      const isPreview = !data.hls_manifest && !!(data.system_preview_video_full_src || data.custom_preview_video_full_src)
      return (
         <>
            {
               videoIsSfw && (
                  <AgeVerificationFrame
                     className='flex z-20'
                     onClickVerifyAgeButton={ _ => {} }
                  />
               )
            }
            <VideoJsHlsPlayer
               isNextApp
               isVrPlaying={  data.is_vr_video  }
               src={ data.hls_manifest || data.system_preview_video_full_src || data.custom_preview_video_full_src }
               // src={ 'https://demo.unified-streaming.com/k8s/features/stable/video/tears-of-steel/tears-of-steel.ism/.m3u8' }
               poster={ poster }
               onVideoPlay={ addView }
               isAutoPlay={ true }
               userInfo={
                  {
                     username: show_member_info && show_member_username ? authUser?.username : null,
                     email: show_member_info && show_member_email ? authUser?.email : null,
                     ...watermarks_options,
                     show_member_info,
                  }
               }
               dashUri={  data.dash_manifest  }
               isDrmProtected={ data.drm_protection && !isPreview && !data.drm_adding_in_progress }
               isTokenBasedLicenseIssuance={ isDrmTokenBasedLicenseIssuanceForMember(authUser?.uuid) }
               screenWidth={ 1026 }
               authToken={ authToken }
               getLicenseToken={ (type) => {
                  if(getDrmVideoLicenseToken){
                     getDrmVideoLicenseToken(data.id, type)
                  }
               } }
               getDrmVideoLicenseProxyUrl={ (type) => {
                  if(getDrmVideoLicenseProxyUrl){
                     getDrmVideoLicenseProxyUrl(data.id, type)
                  }
               } }
            />
         </>
      )
   }

   if(previewSrc){
      return (
         <MediaPreviewVideo
            src={ previewSrc }
            poster={ poster }
            primaryColor={ primaryColor }
            previewIsSFW={ previewIsSFW }
            posterIsSfw={ posterIsSfw }
            showPlayIcon={ false }
            autoPlay={ autoPlayPreview }
            showVolumeButton={ Boolean(data?.custom_preview_video_full_src) }
            videoId={ data.id }
            blurhash={ data.blurhash }
         />
      )
   }
   if(!poster){ // UNLOCKED STATE
      return (
         <MediaLockedCard blurhash={ data.blurhash } />
      )
   }

   return (
      <>
         <MediaImageCard
            poster={ poster }
            posterIsSfw={ posterIsSfw }
         />
         {
            isAgeVerificationRequired && (
               <AgeVerificationFrame
                  className='cover_image_wrapper_hover_element hidden z-10'
                  onClickVerifyAgeButton={ _ => {} }
               />
            )
         }
      </>
   )

}

VideoMediaContent.propTypes = {
   data: PropTypes.object,
   src: PropTypes.string,
   isAgeVerificationRequired: PropTypes.bool,
   autoPlayPreview: PropTypes.bool,
   primaryColor: PropTypes.string,
   siteInfo: PropTypes.object,
   authUser: PropTypes.object,
   addView: PropTypes.func,
   getDrmVideoLicenseProxyUrl: PropTypes.func,
   getDrmVideoLicenseToken: PropTypes.func,
   authToken: PropTypes.string,
};

export default VideoMediaContent;
